import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import { toPx } from "../../utils/units";

import type { MacroLiteraryDesignVisualData, SlideState } from "../../types";
import type { SlideViewMode } from "../slide/slide";

const VERTICAL_MACRO_DESIGN_DEFAULT_WIDTH = 680;

@customElement("bp-macro-literary-design-slide")
export class MacroLiteraryDesignSlide extends LitElement {
  @property()
  data?: MacroLiteraryDesignVisualData;

  @property({ attribute: "hide-title" })
  hideTitle?: boolean;

  @property()
  slideState?: SlideState;

  @property({ attribute: "title-wraps-2-lines" })
  titleWraps2Lines?: boolean;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    if (!this.data) return;

    this.style.setProperty(
      "--vertical-width",
      toPx(VERTICAL_MACRO_DESIGN_DEFAULT_WIDTH)!,
    );

    const { config } = this.data;

    return html`
      <bp-zoomable-slide
        ?hide-title=${this.hideTitle}
        ?title-wraps-2-lines=${this.titleWraps2Lines}
        view-mode="${this.viewMode}"
        .slideState=${this.slideState}
      >
        <div slot="title">
          <slot name="title"></slot>
        </div>
        <div slot="content"><bp-macro-literary-design .data="${config}" /></div>
      </bp-zoomable-slide>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-macro-literary-design-slide": MacroLiteraryDesignSlide;
  }
}
